import { Result } from "src/utils/Result"
import { deleteTeamMember } from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"
import { appInfo } from "src/constants/AppInfo"

type QuitOrganizationRequestParams = {
  accessToken: string
  organizationMemberId: string
}

type QuitOrganizationSuccess = unknown

type QuitOrganizationFailure = {
  message: string
} 

export const quitOrganization = async (params: QuitOrganizationRequestParams): Promise<Result<QuitOrganizationSuccess, QuitOrganizationFailure>> => {
  const {accessToken, organizationMemberId} = params
  return execApi(
    () => deleteTeamMember(accessToken, {
      input: {
        id: organizationMemberId
      },
      appInfo
    }),
    _ => undefined,
    {
      identifiers: ["quitOrganization", "deleteTeamMember"],
      defaultErrorMessage: "団体からの脱退に失敗しました。"
    }
  )
}
